import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

export default new Router({
	routes: [
		// {
		// 	path: '/',
		// 	component: () => import( /* webpackChunkName: "home" */ '../components/layout/Home'),
		// 	redirect: '/Homepage',
		// 	meta: {
		// 		title: ''
		// 	},
		// 	children:[
		// 		{
		// 			path: '/Homepage',
		// 			component: () => import( /* webpackChunkName: "home" */ '../components/page/Homepage'),
		// 			meta: {
		// 				title: 'demo',
		// 				roles: ['Homepage']
		// 			},
		// 		},

		// 	]
		// },
		{
			path: '/',
			component: () => import('../components/page/Homepage/index.vue'),
			redirect: '/Homepage',
			meta: {
				title: '首页'
			},
		},
		{
			path: '/Homepage',
			component: () => import('../components/page/Homepage/index.vue'),
			meta: {
				title: '首页'
			},
		},
		{
			path: '/Login',
			component: () => import('../components/page/Login/index.vue'),
			meta: {
				title: '登录'
			},
		},
		{
			path: '/findPassword',
			component: () => import('../components/page/findPassword/index.vue'),
			meta: {
				title: '找回密码'
			},
		},
	]
});